<template>
  <div>
    <v-card class="mx-4 my-4" elevation="12" shaped>
      <v-row>
        <div class="ml-10 mt-4">
          <v-list-item-subtitle>School Closes: {{term.dsc}}</v-list-item-subtitle>
          <v-list-item-subtitle>School Re-Opens: {{term.dsrop}}</v-list-item-subtitle>
        </div>
        <v-spacer></v-spacer>
        <div class="mr-16 mt-4">
          <v-list-item-subtitle>Student Total: {{term.total | truncateDecimals}}</v-list-item-subtitle>
          <v-list-item-subtitle>Student Average: {{term.average | truncateDecimals}}%</v-list-item-subtitle>
          <v-list-item-subtitle>Promotion: {{term.code}}</v-list-item-subtitle>
        </div>
      </v-row>
      <v-divider></v-divider>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon></v-icon>
          </v-list-item-avatar>
          <v-list-item-title class="mr-8">Subject</v-list-item-title>
          <v-list-item-title>Student Mark</v-list-item-title>
          <v-list-item-title>Level</v-list-item-title>
          <v-list-item-title>Class Average</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <template v-for="(item, i) in termData">
          <v-list-item
            :key="i+Math.random()"
            v-if="item[0] != 'total' && item[0] != 'average' 
                    && item[0] != 'code'&& item[0] != 'dsc' && 
                    item[0] != 'dsrop' && item[0] != 'reason' && item[0] != 'blocked'"
          >
            <v-list-item-avatar>
              <v-icon>mdi-school</v-icon>
            </v-list-item-avatar>
            <v-list-item-title class="mr-8">{{item[0].split('(')[0]}}</v-list-item-title>
            <v-list-item-title>{{(item[1].split('-'))[0] | truncateDecimals}}</v-list-item-title>
            <v-list-item-title>{{(item[1].split('-'))[1]}}</v-list-item-title>
            <v-list-item-title>{{(item[1].split('-'))[2] | truncateDecimals}}</v-list-item-title>
            <v-divider></v-divider>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["term", "termData"],
  filters: {
    truncateDecimals(value) {
      return Number.parseFloat(value).toFixed();
    }
  }
};
</script>

<style>
</style>